type Props<T extends string> = {
  options: readonly T[];
  value: T;
  onChange: (next: T) => void;
};

export function Seg<T extends string>({ options, value, onChange }: Props<T>) {
  return (
    <div className="tcg-seg">
      {options.map((o) => (
        <button
          key={o}
          type="button"
          className={`tcg-seg-item ${value === o ? "on" : ""}`}
          onClick={() => onChange(o)}
        >
          {o}
        </button>
      ))}
    </div>
  );
}
